import { useLocation, useNavigate } from "@tanstack/react-router";
import { useManagementStore } from "@/stores/management-store";
import { MANAGEMENT_ROUTES, PROTECTED_ROUTES } from "@/utils/navigation";

export const useManagementMode = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isManagementArea = location.pathname.startsWith("/management");

  const {
    previousGymPath,
    previousManagementPath,
    setPreviousGymPath,
    setPreviousManagementPath,
  } = useManagementStore();

  const enterManagement = () => {
    setPreviousGymPath(location.pathname);
    const targetPath =
      previousManagementPath || MANAGEMENT_ROUTES.MANAGEMENT_DASHBOARD;
    navigate({ to: targetPath });
  };

  const exitManagement = () => {
    setPreviousManagementPath(location.pathname);
    const targetPath = previousGymPath || PROTECTED_ROUTES.CALENDAR;
    navigate({ to: targetPath });
  };

  return {
    isManagementArea,
    enterManagement,
    exitManagement,
    previousGymPath,
    previousManagementPath,
  };
};
